import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGmail = () => {
  return (
    <g>
      <path d="M14.398 2H1.602C.718 2.001.002 2.673 0 3.501V12.5c.003.828.719 1.499 1.602 1.501h12.796c.883-.002 1.6-.673 1.602-1.501V3.5c-.002-.828-.718-1.5-1.602-1.501zm0 10.5h-1.597V5.9L8 8.749 3.199 5.9v6.6H1.602V3.5h.957L8 6.651l5.441-3.15h.957V12.5z" />
    </g>
  );
};

export default withIcon(IconLogoGmail);
